export default function Heartbeat({ lastCheckIn }) {
  if (!lastCheckIn) {
    return <span style={{ color: "red", fontWeight: "bold" }}>● Offline</span>;
  }

  const last = new Date(lastCheckIn);
  const now = new Date();
  const diffMinutes = (now - last) / 1000 / 60;

  let color = "red";
  let label = "Offline";

  if (diffMinutes <= 2) {
    color = "green";
    label = "Online";
  } else if (diffMinutes <= 10) {
    color = "orange";
    label = "Idle";
  }

  return (
    <span style={{ color, fontWeight: "bold" }}>
      ● {label}
    </span>
  );
}
